var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"site-header"},[_c('img',{staticClass:"site-logo",attrs:{"src":require("../../assets/logo.svg"),"alt":"umbruch Logo"}})])}]

export { render, staticRenderFns }